import { useState, useEffect } from "react";
import { Form, Button } from "react-bootstrap";
import { endPoints } from "../../constant/Environment";
import { useDispatch } from "react-redux";
import { Actions } from "../../redux/Actions/Actions";
import { addData } from "../../Utility/API";
import { useNavigate, useLocation, Navigate } from "react-router-dom";
import Toaster from "../../components/Toast";
import { ErrorToast, SuccesToast } from "../../components/Toast/message";
import Loader from "../../components/Loader";

const VerifyOtp = () => {
  const [otp, setOtp] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [validated, setValidated] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const loginData = location.state?.loginData;

  useEffect(() => {
    // Show the login success message on VerifyOtp page
    if (loginData?.message) {
      SuccesToast(loginData.message);
    }
  }, [loginData]);

  if (!loginData) {
    return <Navigate to="/login" replace />;
  }

  const handleSubmit = async (event) => {
    const form = event.currentTarget;
    event.preventDefault();
    if (form.checkValidity() === false) {
      event.stopPropagation();
      setValidated(true);
      return;
    }

    let url = `${endPoints.api.VERIFY_USER_OTP}`;
    setIsLoading(true);
    
    // Prepare payload with OTP and login response data
    let data = {
      idUser: loginData.data.idUser,
      login: loginData.data.login,
      login_otp: otp,
      token: loginData.data.token,
    };
    
    await addData(url, data)
      .then((response) => {
        setIsLoading(false);
        if (response.data.status === "success") {
          // Save login data to sessionStorage and Redux after OTP verification
          const userloginData = response.data;
          sessionStorage.setItem("user", JSON.stringify(userloginData));
          sessionStorage.setItem(
            "session",
            JSON.stringify(userloginData.data.sessionId)
          );
          dispatch({ type: Actions.LOGIN, data: { user: userloginData } });
          navigate("/Home");
        } else { 
          ErrorToast(response.data.message);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        ErrorToast("OTP verification failed. Please try again.");
        console.error(error);
      });
  };

  return (
    <div>
      <section className="login-page-section">
        <Toaster />
        {isLoading && <Loader spinner={true} visible={isLoading} />}
        <div className="login-form-div">
          <Form
            className="login-form"
            noValidate
            validated={validated}
            onSubmit={handleSubmit}
          >
            <h2 className="mb-4">Verify OTP</h2>
            <Form.Group className="mb-3" controlId="OTP">
              <Form.Control
                required
                placeholder="Enter OTP"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
              />
              <Form.Control.Feedback type="invalid">
                Please enter OTP.
              </Form.Control.Feedback>
            </Form.Group>

            <div className="login-btn-last mt-5">
              <Button className="login-btn-form" variant="primary" type="submit">
                Verify
              </Button>
            </div>
          </Form>
        </div>
      </section>
    </div>
  );
};

export default VerifyOtp;
